module.exports = __webpack_public_path__ + "img/pashupati_biscuits.ddf2bb1b.png";